import { type FC } from 'react'
import { type BulkCsvRow } from './bulkCsvRows'
import { type BulkChipStatus, BulkInviteRowStatusChip } from './BulkInviteRowStatusChip'

export interface BulkTableRow {
  row: BulkCsvRow
  status: BulkChipStatus
  errors: string[]
}

export interface BulkInviteRowsTableProps {
  rows: BulkTableRow[]
}

export const BulkInviteRowsTable: FC<BulkInviteRowsTableProps> = ({ rows }) => (
  <div className='border zocks-border-color-gray-300 rounded-2 overflow-auto'>
    <table className='table mb-0'>
      <thead className='table-light'>
        <tr>
          <th scope='col' className='label-small zocks-text-gray-600 text-uppercase fw-normal'>
            Email
          </th>
          <th scope='col' className='label-small zocks-text-gray-600 text-uppercase fw-normal'>
            Name
          </th>
          <th scope='col' className='label-small zocks-text-gray-600 text-uppercase fw-normal'>
            Role
          </th>
          <th scope='col' className='label-small zocks-text-gray-600 text-uppercase fw-normal text-end'>
            Status
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((tableRow) => (
          <tr key={tableRow.row.index}>
            <td className='paragraph-small zocks-text-gray-600 align-middle'>{tableRow.row.email}</td>
            <td className='paragraph-small zocks-text-gray-900 align-middle'>{`${tableRow.row.firstName} ${tableRow.row.lastName}`.trim()}</td>
            <td className='paragraph-small zocks-text-gray-900 align-middle'>{tableRow.row.role}</td>
            <td className='text-end align-middle'>
              <BulkInviteRowStatusChip status={tableRow.status} errors={tableRow.errors} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)
